"use client"

import { Carousel } from "antd"

import styles from "../../index.module.scss"
import { useSuffix } from "../../SuffixContext"
import { AdComponentTypes } from "../../types"
import { getPrefixCls } from "../../utils"

const prefixCls = getPrefixCls("ADComponent")

export default function Swiper(props: AdComponentTypes) {
  const { AdList, style } = props
  const suffix = useSuffix()
  return (
    <div className={`${prefixCls} ${styles.carousel}`} style={style}>
      <Carousel
        autoplay
        autoplaySpeed={5000}
        effect="fade"
        fade
        dotPosition="bottom"
        style={{
          width: AdList.len,
          height: AdList.width,
          ...style,
        }}
      >
        {AdList.adverts?.map((item) => (
          <div key={item.id} className={styles.carouselItem}>
            <a href={item.link_url} target="_blank" rel="noreferrer">
              <img
                src={`${item.pic_url}${suffix || ""}`}
                alt={item.name}
                loading="lazy"
                style={{
                  width: AdList.len,
                  height: AdList.width,
                }}
              />
            </a>
            <div className={styles.isAdOrSmm}>AD</div>
          </div>
        ))}
      </Carousel>
    </div>
  )
}
